define("shared/utils/plan-route/tables", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.GOAL_DESTINATION = _exports.DEFAULT_DESTINATION = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /** Destinations per the product ruling recorded in LS-9851; role and profile count are not inputs. */
  const GOAL_DESTINATION = _exports.GOAL_DESTINATION = {
    plan_publish: 'cluster.schedule.calendar',
    collaborate_approve: 'account.users.new',
    respond_messages: 'cluster.inbox',
    measure_report: 'cluster.analytics',
    compare_competitors: 'cluster.social-listening.competitors'
  };
  const DEFAULT_DESTINATION = _exports.DEFAULT_DESTINATION = 'cluster.schedule.calendar';
});